import React from "react";
import { images } from "../../data/content";
import { OfferBlock } from "../OfferBlock";
export function FinalCTA() {
  return <section className="bg-brand-light px-4 py-16 md:py-24" data-id="element-165" data-mp="5cqx8czo5x8o">
      <div className="mx-auto max-w-3xl text-center" data-id="element-166" data-mp="3mua6q23j6fpm">
        <h2 className="font-serif text-[30px] font-extrabold leading-tight text-navy md:text-5xl" data-id="element-167" data-mp="3mrnye08tfw6c">
          Ready to stop planning every implant case <em className="italic text-brand" data-id="element-168" data-mp="3dskfoxdk9isd">from scratch?</em>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-ink-muted" data-id="element-169" data-mp="3dvg9qamafnbj">
          You don't need to memorize another hundred pages of information. You need a process you can return to — a structured workflow designed around the decisions that matter.
        </p>
        <img src={images.main} alt="Implant Planning Playbook complete bundle" className="mx-auto mt-6 w-full max-w-xl" data-id="element-170" data-mp="38w3ep2l9j9xv" />
        <p className="mt-4 text-lg font-semibold text-ink" data-id="element-171" data-mp="172m8m3cs6h58">
          Only <span className="font-serif text-5xl font-black text-navy" data-id="element-172" data-mp="171uphs0debvu">$27</span> <span className="font-bold text-navy" data-id="element-173" data-mp="q7lkple36x1f">USD</span>
        </p>
        <p className="mt-1 text-sm text-ink-muted" data-id="element-174" data-mp="l9sg2wsfmb39">Instant Digital Access · Lifetime Access · 5 Bonuses · 7-Day Guarantee</p>
        <div className="mt-8" data-id="element-175" data-mp="z17096y2sibw">
          <OfferBlock label="Get the Implant Planning Playbook™" data-id="element-176" data-mp="z0fbog2wbkv4" />
        </div>
      </div>
    </section>;
}